module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vehicle-hardware-action-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('button', {
    staticClass: "button small alert",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Remove")]), _c('modal-reveal', {
    ref: "modalUpdateHardware",
    attrs: {
      "sizing": "small"
    }
  }, [_c('button', {
    staticClass: "button small warning",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), _c('h2', [_vm._v("Edit Vehicle hardware VH" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Manager"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manager),
      expression: "manager"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.manager = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.managers), function(manager, index) {
    return _c('option', [_vm._v(_vm._s(index))])
  }), 0)])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Serial"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.serial),
      expression: "item.serial"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "serial", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Extra")]), _c('array-edit', {
    attrs: {
      "values": _vm.item.extra
    }
  }), _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "fa fa-download fa-2x text-right",
    attrs: {
      "title": "Click to copy the configuration"
    },
    on: {
      "click": _vm.exportConfiguration
    }
  })]), _c('input', {
    attrs: {
      "id": "clipboard",
      "type": "hidden"
    },
    domProps: {
      "value": JSON.stringify(_vm.item.extra)
    }
  }), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.editHardware
    }
  }, [_vm._v("Edit Hardware")])], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-370df01a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/VehicleHardwareActionButtons.vue
// module id = 2266
// module chunks = 1